import { useFlagship } from "@flagship.io/react-sdk";
import { memo, useCallback, useContext, useEffect, useState } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";
import classNames from "classnames";
import groupBy from "lodash/groupBy";
import { isServerSide } from "app/utils/utils";
import "./DevInfos.scss";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { DataLayerViewerButton } from "app/pages/.shared/DataLayerViewer";
import { ArrowUpIcon, ArrowDownIcon, CrossIcon } from "app/icons/navigation";

const RELEASE_TOAST_DURATION = 4000;

const DevInfos = () => {
	const [expand, toogleExpand] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [showReleaseToast, setShowReleaseToast] = useState(!isServerSide);

	const { flagsData = [], visitorId } = useFlagship();

	const { envVars = {}, strategy, partnerCode } = useContext(AppGlobalsContext);

	const environment = envVars.ENVIRONMENT;

	const showDevInfos =
		environment.includes("test") ||
		environment.includes("canary") ||
		environment.includes("preprod") ||
		environment.includes("e2e");

	const useCases = groupBy(flagsData, "variationName");

	const toggle = useCallback(() => {
		toogleExpand(!expand);
	}, [expand]);

	const closeReleaseToast = useCallback(() => {
		setShowReleaseToast(false);
	}, []);

	useEffect(() => {
		if (!showReleaseToast) {
			return undefined;
		}
		const timeoutId = setTimeout(() => {
			setShowReleaseToast(false);
		}, RELEASE_TOAST_DURATION);
		return () => clearTimeout(timeoutId);
	}, [showReleaseToast]);

	const devInfosClass = classNames("dev-infos", {
		"dev-infos--collapse": !expand,
	});

	const switchDesignMode = () => {
		document.designMode = document.designMode === "on" ? "off" : "on";
	};

	const clearStorage = useCallback(() => {
		setLoading(true);
		var cookies = document.cookie.split("; ");
		for (var c = 0; c < cookies.length; c++) {
			var d = window.location.hostname.split(".");
			while (d.length > 0) {
				var cookieBase =
					encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
					"=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
					d.join(".") +
					" ;path=";
				var p = location.pathname.split("/");
				document.cookie = cookieBase + "/";
				while (p.length > 0) {
					document.cookie = cookieBase + p.join("/");
					p.pop();
				}
				d.shift();
			}
		}

		localStorage.clear();
		sessionStorage.clear();

		setInterval(() => {
			setLoading(false);
			location.reload();
		}, 1000);
	}, []);

	return (
		showDevInfos && (
			<>
				{showReleaseToast && (
					<div className="dev-infos__toast" role="status">
						Current release:
						<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
							{window.__VERSION__}
						</Typography>
						<button
							type="button"
							className="dev-infos__toast-close"
							onClick={closeReleaseToast}
							aria-label="Close"
						>
							<CrossIcon />
						</button>
						<div
							className="dev-infos__toast-progress"
							style={{ animationDuration: `${RELEASE_TOAST_DURATION}ms` }}
						/>
					</div>
				)}
				<div className={devInfosClass}>
					{!isServerSide && (
						<div>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.LARGE}
								isBold
								className="dev-infos__release"
							>
								release : {window.__VERSION__}
							</Typography>
							<div className="dev-infos__close" onClick={toggle}>
								{expand ? <ArrowUpIcon /> : <ArrowDownIcon />}
							</div>
						</div>
					)}

					<div className="dev-infos__env">
						{partnerCode} - {strategy}
					</div>

					{Object.keys(useCases).length > 0 && (
						<>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
								isBold
								className="dev-infos__title"
							>
								Use cases flagship for visitorID : {visitorId}
							</Typography>
							<div className="dev-infos__list">
								{Object.keys(useCases).map((useCase, index) => {
									return (
										<div key={index} className="dev-infos__item">
											<div className="dev-infos__slug">{useCase}</div>
											<ul className="dev-infos__flags">
												{useCases[useCase].map((flagData = {}, index) => {
													return (
														<li key={index} className="dev-infos__flag">
															{flagData.key} :{" "}
															<b>{JSON.stringify(flagData.value)}</b>
														</li>
													);
												})}
											</ul>
										</div>
									);
								})}
							</div>
						</>
					)}

					<div className="dev-infos__clear-storage-cta">
						<Button
							variant={BUTTON_VARIANTS.FILLED}
							size={BUTTON_SIZES.SMALL}
							onClick={clearStorage}
							loading={isLoading}
							label="Clear cookies and reload the page"
						/>
					</div>

					<div className="dev-infos__clear-storage-cta">
						<Button
							variant={BUTTON_VARIANTS.STROKE}
							size={BUTTON_SIZES.SMALL}
							onClick={switchDesignMode}
						>
							Activate design mode
						</Button>
					</div>

					<div className="dev-infos__clear-storage-cta">
						<DataLayerViewerButton />
					</div>
				</div>
			</>
		)
	);
};

DevInfos.propTypes = {};

export default memo(DevInfos);
